// usePlayerConfig.js

import playerEquipmentsStore from "../store/playerEquipments";

// Custom hook để sử dụng và cập nhật cấu hình player
const usePlayerEquipment = (playerId) => {
    const playerEquipments = playerEquipmentsStore((state) => state.playerEquipments);
    const updateSingleEquipment = playerEquipmentsStore((state) => state.updateSingleEquipment);
    const updatePlayerEquipment = playerEquipmentsStore((state) => state.updatePlayerEquipment);
    const updateMultiplePlayersEquipment = playerEquipmentsStore((state) => state.updateMultiplePlayers);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        equipments: playerId == null ? {} : playerEquipments[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        playerEquipments,
        updateSingleEquipment,
        updatePlayerEquipment,
        updateMultiplePlayersEquipment,
    };
};

export default usePlayerEquipment;
